import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const MagazineIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        height={height}
        viewBox="0 0 20 21"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g style={{ stroke: color, strokeWidth: 2, fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' }} transform="translate(-2 -1)">
            <path d="m20.9999958 3.25v16.2518874c-6-.3874736-9 .1118973-9 1.4981126 0 0 0-11.04461252 0-15.38092 0-2.36275895 3-3.15245228 9-2.36908z" />
            <path d="m2.99999577 3.25v16.2518874l.74966048-.044647.71706655-.0350119.68447261-.0253766.65187868-.0157413c.10593028-.0018206.21050249-.0032398.31371661-.0042575l.60298778-.0012884.57039384.0083467.53779991.0179821.50520598.0276173c.16296967.0108116.32050701.0232291.47261204.0372525l.44001811.0468878c1.76550474.2154392 2.68220914.6817964 2.75011314 1.3990715l.0040743.0533948v-15.3470374c0-1.92878281-1.999167-2.809292-5.99750107-2.64152756l-.61474386.03302672c-.10495626.0068148-.21116201.01428476-.31861724.0224099l-.65972511.05661288c-.22490629.02149164-.4548105.04560397-.68971262.07233698z" />
        </g>
    </svg>
);

export default MagazineIcon;
